import { parseISO } from "date-fns"

import { AvailableForBooking } from "utils/interfaces"

export function getOnlineOrOfflineDate(
    online: boolean | undefined,
    availableForBooking: AvailableForBooking,
    onlyFree = false
) {
    if (online === undefined) return
    const dateString = onlyFree
        ? availableForBooking["free"]
        : availableForBooking[online ? "online" : "in_person"]
    return dateString ? parseISO(dateString) : new Date()
}
